<template>
  <v-card class="ma-2" style="flex: 1 0 auto" v-if="configRsync">
    <v-card-title
      class="pb-0"
      style="flex: 1 0 auto; flex-direction: column; align-items: stretch; position: relative; height: 100%"
    >
      <v-layout class="pb-0" row wrap style="flex: 0 0; align-items: flex-start; border-bottom: 1px solid #ccc">
        <span class="subheading mb-1" style="flex: 0 0 auto">{{ $t('Pilot.FtpRsync.ConfigurationRsync') }}</span>
      </v-layout>
      <div style="flex: 1 0; position: relative">
        <v-layout
          class="pb-0"
          row
          wrap
          style="flex: 1 0; align-items: flex-start; overflow: auto; position: absolute; height: 100%; width: 100%"
        >
          <v-flex xs6 pr-2 class="inline-block">
            <v-text-field hide-details v-model="configRsync.server" :label="$t('Pilot.FtpRsync.Server')" />
            <number-field-factor hide-details v-model.number="configRsync.port" :label="$t('Pilot.FtpRsync.Port')" />
            <v-text-field hide-details v-model="configRsync.login" :label="$t('Pilot.FtpRsync.Login')" />
            <v-text-field hide-details v-model="configRsync.password" :label="$t('Pilot.FtpRsync.Password')" />
          </v-flex>
          <v-flex xs6 pl-2 class="inline-block">
            <div class="mt-2">{{ $t('Pilot.FtpRsync.SyncPaths') }} :</div>
            <div class="checkboxGroup">
              <v-checkbox
                hide-details
                v-for="syncPath in SyncPathsArr"
                class="ml-0 my-0"
                v-model="configRsync.syncPaths"
                :title="$t(`Pilot.FtpRsync.${syncPath}Tooltip`)"
                :label="syncPath"
                :value="syncPath"
                :key="syncPath"
                style="flex: 0 0 !important; min-width: 51px; min-height: 20px"
              ></v-checkbox>
            </div>
            <v-text-field hide-details v-model="configRsync.dstPaths" :label="$t('Pilot.FtpRsync.DstPaths')" />
          </v-flex>
        </v-layout>
      </div>
      <v-layout class="pt-0" row wrap style="flex: 0 0; align-items: flex-start">
        <v-spacer />
        <v-btn @click.prevent="restoreConfigRsync()" small
          >{{ $t('Fleet.Clear') }}<v-icon small right>mdi-replay</v-icon></v-btn
        >
        <v-btn @click.prevent="applyToAll()" :loading="saving" :disabled="saving" small color="primary"
          >{{ $t('Fleet.ApplyToAll') }}<v-icon small right>mdi-content-save</v-icon></v-btn
        >
      </v-layout>
    </v-card-title>
  </v-card>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, nextTick } from 'vue'
import { SyncPathsArr } from '@/enum/SyncPath'
import { AloDbFleet } from '@/models/alodb/AloDbFleet'
import store from '@/store'

const props = defineProps<{
  fleet: AloDbFleet
}>()

const configRsync = computed(() => store.state.fleet.context?.configRsync)

onMounted(() => {
  if (!store.state.fleet.context?.configRsync || store.state.fleet.context.configRsync.idFleet != props.fleet.id) {
    restoreConfigRsync()
  }
})

const saving = ref(false)

const missions = computed(
  () => props.fleet.activeMissionIds?.map((id) => store.myGetters?.missionsById[id])?.filter((m) => !!m) ?? []
)

function restoreConfigRsync() {
  store.state.fleet.context.configRsync = {
    idFleet: props.fleet.id,
    login: '',
    password: '',
    port: 22,
    server: '',
    sftp: true,
    dstPaths: '',
    syncPaths: [],
    privateKey: ''
  }
}

async function applyToAll() {
  if (saving.value) return
  saving.value = true

  for (const mission of missions.value.filter((m) => m.misActifOn)) {
    if (mission.gliId == null) return
    try {
      await store.myActions.GLIDER_IRIS_RSYNC_REQUEST(mission.gliId!)
      await store.myActions.GLIDER_UPDATE_MODIFIED_RSYNC({
        itemId: mission.gliId!,
        newProperties: {
          mod_settings: {
            RSync_remote: {
              dst_paths: configRsync.value.dstPaths,
              login: configRsync.value.login,
              password: configRsync.value.password,
              port: configRsync.value.port,
              private_key: configRsync.value.privateKey,
              server: configRsync.value.server,
              sftp: configRsync.value.sftp,
              sync_paths: configRsync.value.syncPaths.filter((p: any) => SyncPathsArr.some((pa) => pa == p))
            }
          }
        }
      })
      await store.myActions.GLIDER_IRIS_RSYNC_SAVE_REQUEST(mission.gliId!)
    } catch (e) {
      console.error(e)
    }
  }
  nextTick(() => {
    restoreConfigRsync()
    saving.value = false
  })
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.subheading {
  font-weight: bold;
}

.disable {
  overflow: hidden !important;
  position: relative;
}

.disable::before {
  position: absolute;
  content: '';
  left: 0px;
  right: 0px;
  top: 0px;
  height: 8000%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1;
}
</style>
